import DashboardAR from "./dashboardAR";
import DashboardAP from "./dashboardAP";

const Dashboard = () => {
  const isARLocation =
    JSON.parse(sessionStorage.getItem("userData")).locationId === 1;

  return (
    <>
      { isARLocation ? (
        <DashboardAR />
      ) : (
        <DashboardAP />
      )}
    </>
  );
};

export default Dashboard;
